<template>
  <v-card 
    v-if="infoType" id="metaBox" max-width="350" width="100%" flat color="lsidebg" 
    class="mb-3 mr-sm-3 mr-md-0 pb-2 lside-wdgt" 
  > 
    <!--Header-->
    <div class="l_case" style="padding-top:6.5px;">

      <v-card-title class="py-0 pr-2 pl-2 mb-4 ">
        <h5 class="wdgt-title mb-0" >{{$t('judinfobox.caseinfo')}}</h5>
        <v-spacer></v-spacer>
        <v-tooltip right max-width="250" color="liiblack lighten-1" > 
          <template v-slot:activator="{ on, attrs }">
            <router-link to="/news#infobox" >
              <span class="beta-tag link--text" style="background-color: var(--v-l_case-lighten1);" v-bind="attrs" v-on="on" >
                {{$t('btntxt.newfeature')}}
              </span>
            </router-link>
          </template>
          <span class="body-2">{{$t('judinfobox.intro')}}</span>

        </v-tooltip>
        </v-card-title>

        <v-card-subtitle class="py-0 pr-2 pl-2 pb-1">
          <h5 class="mb-0" v-if="infoType==='drug'">{{$t(`judinfobox.dt.title`)}}</h5>
          <h5 class="mb-0" v-else>{{$t(`judinfobox.${infoType}.title`)}}</h5>
        </v-card-subtitle>
    </div>
    
    <!-- DT infobox items -->
    <template v-if="infoboxFormatted && infoType==='drug'">
      <!--select defendant-->
      <v-radio-group v-if="Object.keys(infoboxFormatted.content).length>1"
        v-model="activeDefendantIdx"
        class="px-2 py-1 ma-0 radio-selections"
        dense hide-details
      >
      <template v-slot:label><span class="font-italic caption mb-1">{{$t('judinfobox.dt.selecthint')}}</span></template>
        <v-radio v-for="(defendant, defNum) in infoboxFormatted.content" :key="defNum"
          :label="$i18n.t('judinfobox.dt.f_defendant', [defNum])"
          :value="defNum"
          active-class="selected-radio"
          class="mb-1 pa-0"
        />
      </v-radio-group>
      <v-divider class="link" v-if="Object.keys(infoboxFormatted.content).length>1"></v-divider>

      <div class="py-1 px-2 link lighten-4">
        <h5 class="wdgt-subtitle mb-0" >
          {{ Object.keys(infoboxFormatted.content).length > 1 ? 
            $t('judinfobox.dt.f_defendant', [activeDefendantIdx]) : $t('judinfobox.dt.f_defendant_single')}}
        </h5>
      </div>
    
      <v-card-text v-if="activeDefendant" class="px-2 pt-1 pb-0">
        <!--defendant info-->
        <JudgmentKeyValue type="dt" :item="activeDefendant.defendant" />

        <!--charge banner (name + no)-->
        <div>
          <v-expansion-panels flat class="charge-panel" multiple v-model="panels">
            <v-expansion-panel v-for="(item, chargeNum) in activeDefendant.defendant_charges" :key="chargeNum" class="mt-1 mb-1">
              <v-expansion-panel-header class="link lighten-4 px-2 py-1">
                <h5 class="wdgt-subtitle mb-0">
                  {{ Object.keys(activeDefendant.defendant_charges).length>1 ? 
                    $t('judinfobox.dt.f_charge', [chargeNum]) : $t('judinfobox.dt.f_charge_single')}}
                </h5>
              </v-expansion-panel-header>

              <!-- def-charge items-->
              <v-expansion-panel-content class="pt-2" color="lsidebg">
                <JudgmentKeyValue type="dt" :item="item" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

      </v-card-text>
    </template>

    <!-- PI infobox items -->
    <template v-if="infoboxFormatted && infoType==='pi'">
      <v-card-text class="px-2 pt-2 pb-0">
        <JudgmentKeyValue type="pi" :item="infoboxFormatted.content" />
      </v-card-text>
    </template>

    <!-- info disclaimer -->
    <v-card-text class="px-2 py-0">
      <p class="text-caption mb-0 mt-2 infobox-disclaimer">{{$t('judinfobox.case_disclaimer')}}</p>
    </v-card-text>
  </v-card>
</template>

<script>
  import synopsisHelper from '@/scripts/synopsishelper'
  import JudgmentKeyValue from './JudgmentKeyValue.vue'
  export default {
    name: 'JudgmentInfobox',
    props: {
      infoBoxInfo: {type: Object}
    },
    components: {
      JudgmentKeyValue,
    },
    data(){
      return {
        infoType: null,
        infoboxFormatted: null,
        activeDefendantIdx: 1,  // start from 1
        panels: [],
        showBetaTag: false,
      }
    },
    watch: {
      infoBoxInfo: {
        handler: function(nv){
          this.formatInfo()
        },
        deep: true
      },
      activeDefendantIdx(nv){
        this.$nextTick(() =>
          this.panels = Object.keys(this.infoboxFormatted.content[nv].defendant_charges).map((key, idx) => idx)
        )
      }
    },
    methods: {
      formatInfo() {
        try {
          this.infoboxFormatted = synopsisHelper.formatInfoBox(this.infoBoxInfo.info_box)
          this.infoType = this.infoboxFormatted.type
          if (this.infoType === 'drug') {
            this.activeDefendantIdx = Object.keys(this.infoboxFormatted.content)[0] || 1
          }
        } catch (e) {
          console.error(e)
          this.infoType = null
        }
      }
    },
    computed: {
      activeDefendant() {
        if (this.infoboxFormatted && this.infoType === 'drug') {
          return this.infoboxFormatted.content[this.activeDefendantIdx]
        }
        return null
      }
    },
    mounted() {
      if (this.infoBoxInfo) {
        this.formatInfo()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  a {
    @include link-no-underline-block-hover;
  }

  /*defendant radio selection*/
  .radio-selections::v-deep legend{
    padding-bottom: 2px  !important;    
  }
  .radio-selections::v-deep label{
    color: liiblack;
    font-size: 0.9rem;
  }
  .selected-radio{
    background-color: var(--v-link-lighten5);
    font-weight: bold;
  }


  /*def-charge expansion panels*/
  .charge-panel::v-deep .v-expansion-panel-content__wrap{
    padding: 0px 0px;
  }
  .charge-panel::v-deep .v-expansion-panel--active > .v-expansion-panel-header{
    min-height: inherit;
  }

  .infobox-disclaimer{
    font-size: 0.7rem !important;
    line-height: 0.9rem ;
    letter-spacing: 0em !important;
    color: var(--v-darkgrey-base);
    text-indent: -10px;
    padding-left: 10px;
  }

</style>